var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._t("trigger", null, {
        generateSpreadsheet: _vm.generateSpreadsheet,
        start: _vm.startDate,
        end: _vm.endDate,
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }